import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, first, BehaviorSubject, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { HTTP_ENDPOINTS } from '../external/http';
import { BuildDetailsDto, MachineId, TenantId } from '@allbesmart/web-app-common';
import { AvailableBuildCommitDto } from "../models/configuration-file-details/available-build-commit-dto";

@Injectable({
  providedIn: 'root'
})
export class BuildService {

  private buildDetails$: BehaviorSubject<BuildDetailsDto[]> = new BehaviorSubject<BuildDetailsDto[]>([]);
  private buildDetailsSubscription?: Subscription;

  private availableCommit$: BehaviorSubject<AvailableBuildCommitDto | undefined> = new BehaviorSubject<AvailableBuildCommitDto | undefined>(undefined);
  private availableCommitSubscription?: Subscription;

  constructor(private http: HttpClient) {
  }

  public fetchAllBuildDetails(): void {
    this.buildDetailsSubscription?.unsubscribe();
    this.buildDetailsSubscription = this.http.get<BuildDetailsDto[]>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.BUILD_BASE_PATH}/${HTTP_ENDPOINTS.BUILD_DETAILS}`)
      .pipe(first()).subscribe(buildDetails => this.buildDetails$.next(buildDetails));
  }

  public getBuildDetails$(): BehaviorSubject<BuildDetailsDto[]> {
    return this.buildDetails$;
  }

  public fetchBuildExecutable(tenantId: TenantId, machineId: MachineId, platform?: string): Observable<HttpResponse<Blob>> {
    const params = platform ? new HttpParams().set('platform', platform) : {};
    return this.http.get(`${environment.apiBasePath}/${HTTP_ENDPOINTS.BUILD_BASE_PATH}/${tenantId}/${machineId}/${HTTP_ENDPOINTS.BUILD_EXECUTABLE}`,
      {responseType: 'blob', observe: 'response', params});
  }

  public fetchAvailableBuildCommit(): void {
    this.availableCommitSubscription?.unsubscribe();
    this.availableCommitSubscription = this.http.get<AvailableBuildCommitDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.BUILD_BASE_PATH}/${HTTP_ENDPOINTS.AVAILABLE_BUILD_COMMIT}`)
      .pipe(first()).subscribe(availableBuildCommitCommit => this.availableCommit$.next(availableBuildCommitCommit));
  }

  public getAvailableBuildCommit$(): BehaviorSubject<AvailableBuildCommitDto | undefined> {
    return this.availableCommit$;
  }

}
